import { render, staticRenderFns } from "./CollectPayment.vue?vue&type=template&id=5f138c5f&scoped=true&"
import script from "./CollectPayment.vue?vue&type=script&lang=js&"
export * from "./CollectPayment.vue?vue&type=script&lang=js&"
import style0 from "./CollectPayment.vue?vue&type=style&index=0&id=5f138c5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f138c5f",
  null
  
)

export default component.exports